var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4529 0.676284L15.1346 1.35257L18.5673 1.35322L22 1.35387V2.70774V4.06161H21.3109H20.6218V14.3955C20.6218 24.0403 20.6159 24.7516 20.5332 25.0635C20.4846 25.2472 20.4322 25.4089 20.417 25.4227C20.4018 25.4365 20.3449 25.5466 20.2906 25.6673C20.1876 25.8966 19.6146 26.5258 19.5088 26.5258C19.4753 26.5258 19.4478 26.5433 19.4478 26.5646C19.4478 26.6004 19.3072 26.6782 18.9884 26.8188C18.5783 26.9996 18.5611 27 11 27C3.43889 27 3.42169 26.9996 3.0116 26.8188C2.69278 26.6782 2.5522 26.6004 2.5522 26.5646C2.5522 26.5433 2.52622 26.5258 2.49452 26.5258C2.34165 26.5258 1.63341 25.6846 1.63341 25.5031C1.63341 25.4635 1.61616 25.4235 1.59508 25.4143C1.57399 25.4051 1.51657 25.2472 1.46747 25.0635C1.38386 24.7505 1.37819 24.0743 1.37819 14.3955V4.06161H0.689095H0V2.70774V1.35387H3.43894H6.87783L7.56075 0.677989L8.24362 0.00210601L11.0075 0.0010532L13.7713 0L14.4529 0.676284ZM4.13457 14.1906V24.3195H11H17.8654V14.1906V4.06161H11H4.13457V14.1906ZM9.59629 14.1906V21.6118H8.24362H6.89095V14.1906V6.76936H8.24362H9.59629V14.1906ZM15.109 14.1906V21.6118H13.7564H12.4037V14.1906V6.76936H13.7564H15.109V14.1906Z",
    fill: "#BD1823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.a8b9227a65e12e9a92e23439dffd1d1f.svg";
export { ForwardRef as ReactComponent };